module.exports = __webpack_public_path__ + "static/media/novotiLogo.63f10e7e.png";